import React from "react";
import {
    authorizeComponent,
    checkAuthorized,
    JmfAuthorizedComponentProps,
    PermissionNameType,
    UnathorizedMode,
} from "@mm-products/java-multima-framework";
import usePermissions from "./usePermissions";

const AuthorizedComponent = <T extends PermissionNameType, DMode extends UnathorizedMode | undefined>({
    children,
    permissions,
    unauthorizedMode,
    permissionsCheck = "all-required",
}: Pick<JmfAuthorizedComponentProps<T>, "permissionsCheck" | "permissions"> & {
    unauthorizedMode: DMode | UnathorizedMode;
    children: DMode extends "no-render" ? React.ReactNode : (authorized: boolean) => React.ReactNode;
}) => {
    const { hasAtLeastOnePermission, hasAllPermissions } = usePermissions();

    const authorized = checkAuthorized(permissionsCheck, hasAllPermissions, permissions, hasAtLeastOnePermission);
    return authorizeComponent(unauthorizedMode, authorized, children);
};

export default AuthorizedComponent;
